'use strict';

var Cleave = require('cleave.js').default;

let allowPositiveNumbersOnly = function () {
    let elements = document.querySelectorAll('[data-cleave-numbers-only="true"]');
    if (!elements.length) {
        return;
    }
    [].forEach.call(elements, (element) => {
        new Cleave(element, {
            numeral: true,
            numeralPositiveOnly: true,
            delimiter: '',
            stripLeadingZeroes: element.dataset.stripLeadingZeroes === 'true'
        });
    });
};

module.exports = {
    allowPositiveNumbersOnly: allowPositiveNumbersOnly
};
